import {Loader2} from "lucide-react";
import {useEffect} from "react";
import {Link, useSearchParams} from "react-router-dom";

import {PublicPageShell} from "@/src/modules/core/components";
import {LOGO_URL_DESKTOP} from "@/src/modules/core/utils/constants";

import {useLogin} from "../hooks";
import {authSerializer} from "../services/serializer";

export default function OneLoginPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const {mutate: login, isPending} = useLogin();

  useEffect(() => {
    if (token) {
      const loginData = authSerializer.serializeToken(token);
      login(loginData);
    }
  }, [token, login]);

  return (
    <PublicPageShell>
      <div className="rounded-lg bg-background p-6 shadow-lg sm:p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="flex items-center justify-center h-16 w-16 rounded-full ">
              <img src={LOGO_URL_DESKTOP} alt="Image" height="100" />
            </div>
            <h1 className="text-2xl font-bold text-slate-800">STARSPRO</h1>
            <p className="text-slate-500">Security Management System</p>
          </div>

          <div className="flex flex-col items-center space-y-4">
            {isPending ? (
              <>
                <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
                <p className="text-slate-600">Signing in...</p>
              </>
            ) : token ? (
              <p className="text-slate-600">Processing authentication...</p>
            ) : (
              <p className="text-red-600">No token provided</p>
            )}
          </div>
          <div className="flex justify-center mt-4">
            <Link to="/login" className="text-sm text-slate-600 hover:underline">
              Back to login
            </Link>
          </div>

          <div className="mt-6 text-center text-xs text-slate-500">
            &copy; {new Date().getFullYear()} STARSPRO. All rights reserved.
          </div>
      </div>
    </PublicPageShell>
  );
}
